module.exports = __webpack_public_path__ + "img/Avator.f7494101.png";